export class FrequentlyUsedToolsConstants {
    public static WEBLAB_NAME = 'AT_BASE_FREQUENTLY_USED_TOOLS_847158'

    private static storeFamilyToFrequentlyUsedToolsMap = new Map<string, string[]>([
        ['IHM', ['Unified Cycle Count', 'PO Receive']],
        ['HOUDINI', ['Outbound Pick', 'Outbound Pick V2', 'Receive v3', 'My Metrics', 'Stage']],
        ['MENDEL', []],
    ])

    public static getFrequentlyUsedToolsForStoreFamily (storeFamily: string): string[] {
        return this.storeFamilyToFrequentlyUsedToolsMap.get(storeFamily) || []
    }

    public static isFrequentlyUsedToolsEnabledForStoreFamily (storeFamily: string): boolean {
        return this.storeFamilyToFrequentlyUsedToolsMap.has(storeFamily)
    }
}
